import axios from "axios";
import { toast } from "react-toastify";
import { API_URL } from "../config/api.config";
import logger from "./logger";

logger.debug("Environment:", process.env.NODE_ENV);
logger.debug("API URL:", API_URL);

const axiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// اعتراض الطلبات
axiosInstance.interceptors.request.use(
  (config) => {
    const token =
      localStorage.getItem("token") || sessionStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // استخراج وإضافة النطاق الفرعي
    const hostname = window.location.hostname;
    const parts = hostname.split(".");
    let subdomain = null;

    // استبعاد النطاقات المحجوزة
    const reservedDomains = ["www", "api", "admin", "mail", "almarjeapro"];

    if (parts.length >= 3) {
      // الإنتاج: subdomain.domain.com
      if (!reservedDomains.includes(parts[0])) {
        subdomain = parts[0];
      }
    } else if (parts.length === 2 && parts[1] === "localhost") {
      // التطوير: subdomain.localhost
      subdomain = parts[0];
    }

    // محاولة استخراج النطاق الفرعي من بيانات المستخدم المخزنة إذا لم يتم العثور عليه في الرابط
    if (!subdomain) {
      try {
        const storedUser = localStorage.getItem("user") || sessionStorage.getItem("user");
        if (storedUser) {
          const user = JSON.parse(storedUser);
          if (user.tenant && user.tenant.subdomain) {
            subdomain = user.tenant.subdomain;
          } else if (user.subdomain) {
            subdomain = user.subdomain;
          }
        }
      } catch (e) {
        logger.error("Error parsing stored user data:", e);
      }
    }

    if (subdomain) {
      config.headers["x-tenant-subdomain"] = subdomain;
    }

    return config;
  },
  (error) => {
    logger.error("Request error:", error);
    return Promise.reject(error);
  }
);

// تخزين الأخطاء المسجلة مسبقاً لتجنب التكرار
const errorLog = new Set();

// اعتراض الاستجابات
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // إنشاء مفتاح للخطأ بناءً على URL وكود الاستجابة
    const errorKey = `${error.config?.url || "unknown"}-${
      error.response?.status || "network"
    }`;

    // تجنب تسجيل نفس الخطأ مرتين
    if (!errorLog.has(errorKey)) {
      logger.error("Response error:", error);
      errorLog.add(errorKey);

      // حذف السجل بعد فترة زمنية لتجنب تضخم الذاكرة
      setTimeout(() => errorLog.delete(errorKey), 5000); // 5 ثواني
    }

    // تصنيف الاستعلامات غير المهمة
    const isQueryEndpoint =
      error.config?.url?.includes("/count") ||
      error.config?.url?.includes("/stats") ||
      error.config?.url?.includes("/notifications");

    if (error.response?.status === 401 && !isQueryEndpoint) {
      localStorage.removeItem("token");
      sessionStorage.removeItem("token");
      window.location.href = "/login";
      return Promise.reject(new Error("جلسة العمل منتهية"));
    }

    if (error.response?.status === 404) {
      // تجنب رسائل الخطأ للاستعلامات غير المهمة
      if (isQueryEndpoint) {
        return Promise.reject(new Error("المورد غير موجود"));
      }
      return Promise.reject(new Error("المورد غير موجود"));
    }

    if (!error.response) {
      // تجنب إظهار الإشعارات للطلبات غير المهمة
      if (!isQueryEndpoint) {
        toast.error("فشل الاتصال بالخادم");
      }
      return Promise.reject(new Error("فشل الاتصال بالخادم"));
    }

    return Promise.reject(error);
  }
);

// Add this to any component temporarily for testing
logger.debug("Current API URL:", process.env.REACT_APP_API_URL);

export default axiosInstance;
